import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';
import type { ResultOf } from 'gql.tada';

const ChecklistItemReceiptQuery = graphql.persisted(
  "ChecklistItemReceipt",
  graphql(`
    query ChecklistItemReceipt($schoolId: ID!, $itemId: ID!) {
      checklistItemReceipt(schoolId: $schoolId, itemId: $itemId) {
        title
        personName
        completedAt
        completedBy
        completedVia
        sections {
          heading
          rows { label value }
        }
        links { label kind url }
      }
    }
  `)
);

type ChecklistItemReceiptResult = NonNullable<ResultOf<typeof ChecklistItemReceiptQuery>>;
export type ChecklistItemReceipt = NonNullable<ChecklistItemReceiptResult['checklistItemReceipt']>;

export { ChecklistItemReceiptQuery };

export function useChecklistItemReceiptQuery(schoolId?: string, itemId?: string) {
  return useQuery(ChecklistItemReceiptQuery, {
    variables: { schoolId: schoolId!, itemId: itemId! },
    skip: !schoolId || !itemId,
  });
}
